import { Grid, Typography } from "@material-ui/core"
import React from "react"
import drops from '../images/2018-02-05-06-26-25-d0c746.png'

export const UserNotFoundPage = () =>
(<Grid container alignItems='center' justify='center'>
    <Grid item>
        <img src={drops} alt='User not found dinosaur' />
    </Grid>
    <Grid item>
        <Typography>User data could not be loaded. Please try signing out and in again</Typography>
    </Grid>
</Grid>)

export const NotFoundPage = () =>
(<Grid container alignItems='center' justify='center'>
    <Grid item>
        <img src={drops} alt='Page not found dinosaur' />
    </Grid>
    <Grid item>
        <Typography>Oops! Looks like that page does not exist</Typography>
    </Grid>
</Grid>)
